import { erpAxios } from '..';

const getUserCollaterals = async (komitent) => {
  const res = await erpAxios.get(`/suduznici/getuserCollaterals/${komitent}`);
  return res.data;
};

export default getUserCollaterals;
